import { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "../styles/Pagination.css";

const PaginationCustom = ({
    totalItems,
    totalPages,
    currentPage,
    setCurrentPage,
    limit,
    setLimit,
    showLimit = true,
    className = ''
}) => {
    const [visiblePages, setVisiblePages] = useState([]);

    useEffect(() => {
        updateVisiblePages(currentPage);
    }, [currentPage]);

    const updateVisiblePages = (page) => {
        const pages = [];

        if (totalPages === 1) {
            pages.push(1);
        } else {
            pages.push(1);

            if (page > 3) {
                pages.push("...");
            }

            const startPage = Math.max(2, page - 2);
            const endPage = Math.min(totalPages - 1, page + 2);

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (page < totalPages - 2) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        setVisiblePages(pages);
    };

    const onNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const onPrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className={`pagination_wrapper ${className}`}>
            <div className="pagination_main">
                <div>
                    <p>Total {totalItems} items</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <span onClick={onPrevious}
                        disabled={currentPage === 1 || !currentPage}>
                        <IoIosArrowBack />
                    </span>
                </div>

                {(totalPages || totalPages >= 1) && (
                    <div className="pagination_count">
                        <ul>
                            {visiblePages.map((page, index) => (
                                <li
                                    key={index}
                                    className={page === currentPage ? "active_page" : ""}
                                    onClick={() => typeof page === "number" && setCurrentPage(page)}
                                >
                                    {page}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="d-flex align-items-center gap-3">
                    <span onClick={onNext}
                        disabled={currentPage === totalPages || !currentPage}>
                        <IoIosArrowForward />
                    </span>
                </div>

                {
                    showLimit &&
                    <div className="option_select">
                        <select onChange={(e) => setLimit(e.target.value)} value={limit}>
                            <option value={10}>10 / Page</option>
                            <option value={20}>20 / Page</option>
                            <option value={50}>50 / Page</option>
                            <option value={100}>100 / Page</option>
                        </select>
                    </div>
                }
            </div>
        </div>
    );
};
export default PaginationCustom;
